import { useContext, useState, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { useStyles } from "./HMIUptimeDowntimeBar.styles";
import { useTranslation } from "react-i18next";
import { HMICachedDataContext } from "contexts/HMICachedDataContext/HMICachedDataContext";
import { percentageChecker } from "utilities/utilities";
import { HMIContext } from "contexts/HMIContext/HMIContext";
import { ShiftOptionsEnum } from "components/ShiftDropdown/ShiftDropdown.view";

export const HMIUptimeDowntimeBar = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { store } = useContext(HMICachedDataContext);
    const [uptimePercentage, setUptimePercentage] = useState<null | number>(null);
    const [downtimePercentage, setDowntimePercentage] = useState<null | number>(null);
    const { shift } = useContext(HMIContext);

    const selectedShiftSeconds =
        shift === ShiftOptionsEnum.current
            ? store.lastTwoShiftsEventReports?.currentShiftTimes
            : store.lastTwoShiftsEventReports?.previousShiftTimes;

    useMemo(() => {
        if (selectedShiftSeconds) {
            if (selectedShiftSeconds.downtime === 0) {
                setDowntimePercentage(0);
                setUptimePercentage(100);
            } else {
                const downtimePercentageCalculated = Math.ceil(
                    (100 * selectedShiftSeconds.downtime) / selectedShiftSeconds.shift,
                );
                const uptimePercentageCalculated = Math.floor(
                    (100 * (selectedShiftSeconds.shift - selectedShiftSeconds.downtime)) / selectedShiftSeconds.shift,
                );
                setDowntimePercentage(percentageChecker(downtimePercentageCalculated));
                setUptimePercentage(percentageChecker(uptimePercentageCalculated));
            }
        }
    }, [selectedShiftSeconds]);

    return (
        <Box className={classes.container}>
            {!uptimePercentage && !downtimePercentage ? (
                <Box className={classes.titleContainer}>
                    <Typography variant="subtitle2" className={classes.title}>
                        {t("HMI.overall_summary.progress_bar.loading")}
                    </Typography>
                </Box>
            ) : (
                <>
                    <Box className={classes.titleContainer}>
                        <Typography variant="subtitle2" className={classes.title}>
                            {t("HMI.overall_summary.progress_bar.uptime").toUpperCase()}
                        </Typography>
                        <Typography variant="h2">{uptimePercentage}%</Typography>
                    </Box>
                    <Box className={classes.progressBar}>
                        <Box className={classes.uptime} sx={{ width: `${uptimePercentage}%` }}></Box>
                        <Box className={classes.downtime} sx={{ width: `${downtimePercentage}%` }}></Box>
                    </Box>
                    <Box className={classes.titleContainer}>
                        <Typography variant="subtitle2" className={classes.title}>
                            {t("HMI.overall_summary.progress_bar.downtime").toUpperCase()}
                        </Typography>
                        <Typography variant="h2">{downtimePercentage}%</Typography>
                    </Box>
                </>
            )}
        </Box>
    );
};
